<template>
  <div class="rounded bg-neutral-200 animate-pulse" />
</template>
